import { Outlet, useLocation } from "react-router-dom";
import Footer from "../components/Footer";

const LayoutFooter = ({ hideFooterPaths = [] }) => {
  const { pathname } = useLocation();

  return (
    <>
      {!hideFooterPaths.includes(pathname) && <Footer />}
      <Outlet />
    </>
  );
};

export default LayoutFooter;
